/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */
/* eslint-disable react/prop-types */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback, useEffect, useMemo, useState } from 'react';
// @ts-expect-error need to add types
import getProperties from 'reporting-data/properties';
import { EDITOR_TYPES } from 'reporting-data/tsTypes/editorTypes';
import { HISTORICAL_REPORTING_METADATA_DELIMITER } from 'reporting-data/constants/historicalReporting';
import { getMetrics } from 'reporting-data/report/configReportGetters';
import { DateActionTypes } from 'reporting-ui-components/constants/trackingConstants';
import { EVENTS } from 'reporting-ui-components/lib/events';
import useCloneTracker from 'reporting-ui-components/lib/useCloneTracker';
import BaseSelectEditorComponent from '../common/BaseSelectEditorComponent';
import { isValidDimensionProperty } from './dimensionEditorUtils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const getNewDimensions = (editorType, originalDimensions, selectedDimension) => {
  const newDimensions = editorType === EDITOR_TYPES.BREAKDOWN ? originalDimensions.slice(0, 1) : [];
  if (!selectedDimension) {
    return newDimensions;
  }
  newDimensions.push(selectedDimension);
  if (editorType === EDITOR_TYPES.BREAKDOWN) {
    return newDimensions;
  }
  const breakdown = originalDimensions.length > 1 ? originalDimensions[1] : null;
  if (breakdown && breakdown !== selectedDimension) {
    newDimensions.push(breakdown);
  }
  return newDimensions;
};
export const BaseDimensionEditor = props => {
  const {
    appUsageTracker,
    isV2FilterExperience,
    onChange,
    report,
    schema: editorSchema,
    strategy: editorStrategy,
    trackingApplicationName,
    trackingAssetType,
    trackingScreenName
  } = props;
  const {
    type: editorType
  } = editorSchema;
  const usageTracker = useCloneTracker(appUsageTracker);
  const [propertiesByName, setPropertiesByName] = useState({});
  const dataType = editorStrategy.getDataType(report);
  const reportDimensions = useMemo(() => editorStrategy.getCurrentValue(report) || [], [editorStrategy, report]);
  const reportMetrics = useMemo(() => getMetrics(report), [report]);
  useEffect(() => {
    getProperties(dataType).then(dataTypeProperties => {
      const properties = dataTypeProperties.get(dataType);
      setPropertiesByName(properties ? properties.toJS() : {});
    });
  }, [dataType]);
  const propertyToOmit = useMemo(() => editorType === EDITOR_TYPES.BREAKDOWN && reportDimensions.length > 0 ? reportDimensions[0] : null, [editorType, reportDimensions]);
  const propertyOptions = useMemo(() => {
    if (Object.keys(propertiesByName).length === 0) {
      return [];
    }
    return editorSchema.properties.reduce((memo, schemaProperty) => {
      const dimensionProperty = propertiesByName[schemaProperty];
      if (schemaProperty === propertyToOmit || !dimensionProperty || !isValidDimensionProperty(dimensionProperty)) {
        return memo;
      }
      return /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */(
        memo.concat({
          text: dimensionProperty.label,
          value: dimensionProperty.name
        })
      );
    }, []);
  }, [editorSchema.properties, propertiesByName, propertyToOmit]);
  const selectedPropertyName = useMemo(() => {
    const editorDimensionIndex = editorType === EDITOR_TYPES.DIMENSION ? 0 : 1;
    if (reportDimensions.length < editorDimensionIndex + 1) {
      return null;
    }
    const dimensionForEditor = reportDimensions[editorDimensionIndex];
    const selectedDimensionOption = propertyOptions.find(option => option.value === dimensionForEditor.split(HISTORICAL_REPORTING_METADATA_DELIMITER)[0]);
    return selectedDimensionOption ? selectedDimensionOption.value : null;
  }, [editorType, propertyOptions, reportDimensions]);
  const isDisabled = editorType === EDITOR_TYPES.BREAKDOWN && reportMetrics.size > 1;
  const handleChange = useCallback(({
    target: {
      value: newDimension
    }
  }) => {
    const newDimensions = getNewDimensions(editorType, reportDimensions, newDimension);
    const dimensionProperties = newDimensions.map(dimension => {
      const propertyInfo = propertiesByName[dimension];
      return propertyInfo || {
        name: dimension
      };
    });
    usageTracker.track(EVENTS.changeSrvDateFilters, {
      action: editorType === EDITOR_TYPES.DIMENSION ? DateActionTypes.GROUP_BY : DateActionTypes.BREAKDOWN_BY,
      assetType: trackingAssetType || 'report',
      applicationName: trackingApplicationName,
      whereScreen: trackingScreenName,
      isNewFilterExperience: isV2FilterExperience
    });
    onChange(editorStrategy.updateReport(report, dimensionProperties));
  }, [editorStrategy, editorType, isV2FilterExperience, onChange, propertiesByName, report, reportDimensions, trackingApplicationName, trackingAssetType, trackingScreenName, usageTracker]);
  if (editorType === EDITOR_TYPES.BREAKDOWN && reportDimensions.length === 0 || propertyOptions.length === 0) {
    return null;
  }
  const label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: editorType === EDITOR_TYPES.DIMENSION ? 'reporting-enablement.reportEditors.dimensionEditor.label.dimension' : 'report-customization-components.customization-components.breakdown-editor-dropdown.config.label'
  });
  const tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
    message: editorType === EDITOR_TYPES.DIMENSION ? 'report-customization-components.customization-components.dimension-editor-dropdown.config.tooltip' : 'report-customization-components.customization-components.breakdown-editor-dropdown.config.tooltip'
  });
  if (isV2FilterExperience) {
    return /*#__PURE__*/_jsx(BaseSelectEditorComponent, {
      tooltipHeader: label,
      options: propertyOptions,
      value: selectedPropertyName,
      searchable: true,
      onChange: handleChange,
      clearable: editorStrategy.isClearable(editorType, report),
      placeholder: I18n.text('settingLabels.dimension.placeholder')
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    tooltip: tooltip,
    children: Object.keys(propertiesByName).length === 0 ? /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "xs"
    }) : /*#__PURE__*/_jsx(Tooltip, {
      title: isDisabled ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.dimension.tooltip.disabled"
      }) : undefined,
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "report-editor-dimension-editor",
        disabled: isDisabled,
        options: propertyOptions,
        clearable: editorStrategy.isClearable(editorType, report),
        searchable: true,
        value: selectedPropertyName,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingLabels.dimension.placeholder"
        }),
        onChange: handleChange
      })
    })
  });
};
export const __TESTABLE__ = {
  getNewDimensions
};